import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { LocalStore } from '@shared/store/local-store';

export const LocalStoreResolver: ResolveFn<void> = (): Promise<void> => {
  return inject(LocalStore).init();
};
